export const LISTS = [
  {
    label: "Talent match",
    value: 1,
    badges: {
      email: { value: 200, color: "info", colorDepth: "800" },
      phone: { value: 25, color: "leave", colorDepth: "500" },
    },
  },
  {
    label: "Pipeline",
    value: 2,
    badges: {
      email: { value: 126, color: "info", colorDepth: "800" },
      phone: { value: 54, color: "leave", colorDepth: "500" },
    },
  },
  {
    label: "Submission",
    value: 3,
    badges: {
      email: { value: 71, color: "info", colorDepth: "800" },
      phone: { value: 61, color: "leave", colorDepth: "500" },
    },
  },
  {
    label: "Shortlisted",
    value: 4,
    badges: {
      email: { value: 98, color: "info", colorDepth: "800" },
      phone: { value: 47, color: "leave", colorDepth: "500" },
    },
  },
];

const CAMPAIGN_FIELD_CONFIGS = {
  default: {
    fields: [
      {
        name: "campaignName",
        type: "text",
        label: "Campaign Name",
        placeholder: "Campaign Name",
      },
      { name: "source", type: "select", label: null, placeholder: "Select" },
      { name: "sourceId", type: "select", label: null, placeholder: "Select" },
      {
        name: "template",
        type: "select",
        label: "Template",
        placeholder: "Select",
      },
    ],
  },
  "AI Call": {
    fields: [
      {
        name: "campaignName",
        type: "text",
        label: "Campaign Name",
        placeholder: "Campaign Name",
      },
      {
        name: "configurationName",
        type: "text",
        label: "Configuration Name",
        placeholder: "Configuration Name",
      },
      {
        name: "count",
        type: "text",
        label: "Count ",
        placeholder: "5 to 20",
      },
      // {
      //   name: "dateTime",
      //   type: "datepicker",
      //   label: "Select Date and Time",
      //   placeholder: "Select date and time",
      // },
      {
        name: "selectAccount",
        type: "select",
        label: "Select Account",
        placeholder: "Select account",
      },
    ],
  },
};

const CAMPAIGN_TYPE_OPTIONS = {
  Email: {
    label: "Email",
    fieldLabels: {
      source: "Email source",
      id: "Email ID",
    },
    fieldConfig: "default",
    options: {
      sources: [
        { label: "Outlook", value: "Outlook" },
        { label: "Gmail", value: "Gmail" },
        { label: "SendGrid", value: "SendGrid" },
      ],
      sourceIds: [
        { label: "astha_v@gmail.com", value: "astha_v@gmail.com" },
        { label: "john@outlook.com", value: "john@outlook.com" },
        { label: "team@company.com", value: "team@company.com" },
      ],
      templates: [
        { label: "Template 1", value: "Email Template 1" },
        { label: "Template 2", value: "Email Template 2" },
        { label: "Template 3", value: "Email Template 3" },
      ],
      statuses: [
        { label: "Undelivered", value: "Undelivered" },
        { label: "Delivered", value: "Delivered" },
        { label: "Opened", value: "Opened" },
        { label: "Clicked", value: "Clicked" },
        { label: "Bounced", value: "Bounced" },
      ],
    },
  },

  "AI Call": {
    label: "AI Call",
    fieldLabels: {
      source: "Phone source",
      id: "Phone ID",
    },
    fieldConfig: "AI Call",
    options: {
      selectAccount: [
        { label: "Version 1", value: "Version 1" },
        { label: "Version 2", value: "Version 2" },
      ],
      statuses: [
        { label: "Answered", value: "Answered" },
        { label: "Unanswered", value: "Unanswered" },
        { label: "Busy", value: "Busy" },
        { label: "Failed", value: "Failed" },
        { label: "Voicemail", value: "Voicemail" },
      ],
    },
  },

  SMS: {
    label: "SMS",
    fieldLabels: {
      source: "SMS source",
      id: "SMS ID",
    },
    fieldConfig: "default",
    options: {
      sources: [
        { label: "Twilio SMS", value: "Twilio SMS" },
        { label: "MessageBird", value: "MessageBird" },
        { label: "Nexmo", value: "Nexmo" },
      ],
      sourceIds: [
        { label: "+1234567890", value: "+1234567890" },
        { label: "+0987654321", value: "+0987654321" },
        { label: "+1122334455", value: "+1122334455" },
      ],
      templates: [
        { label: "SMS Template 1", value: "SMS Template 1" },
        { label: "SMS Template 2", value: "SMS Template 2" },
        { label: "SMS Template 3", value: "SMS Template 3" },
      ],
      statuses: [
        { label: "Sent", value: "Sent" },
        { label: "Delivered", value: "Delivered" },
        { label: "Failed", value: "Failed" },
        { label: "Clicked", value: "Clicked" },
      ],
    },
  },

  WhatsApp: {
    label: "WhatsApp",
    fieldLabels: {
      source: "WhatsApp source",
      id: "WhatsApp ID",
    },
    fieldConfig: "default",
    options: {
      sources: [
        { label: "WhatsApp Business", value: "WhatsApp Business" },
        { label: "Twilio WhatsApp", value: "Twilio WhatsApp" },
        { label: "MessageBird WhatsApp", value: "MessageBird WhatsApp" },
      ],
      sourceIds: [
        { label: "+1234567890", value: "+1234567890" },
        { label: "+0987654321", value: "+0987654321" },
        { label: "+1122334455", value: "+1122334455" },
      ],
      templates: [
        { label: "WhatsApp Template 1", value: "WhatsApp Template 1" },
        { label: "WhatsApp Template 2", value: "WhatsApp Template 2" },
        { label: "WhatsApp Template 3", value: "WhatsApp Template 3" },
      ],
      statuses: [
        { label: "Sent", value: "Sent" },
        { label: "Delivered", value: "Delivered" },
        { label: "Read", value: "Read" },
        { label: "Failed", value: "Failed" },
      ],
    },
  },
};

/**
 * Get campaign type options with fallback
 * @param {string} campaignType - The campaign type (Email, SMS, etc.)
 * @param {string} optionType - The option type (sources, sourceIds, templates, statuses)
 * @returns {Array} Array of options
 */
export const getCampaignOptions = (campaignType, optionType) => {
  const config = CAMPAIGN_TYPE_OPTIONS[campaignType];
  if (!config || !config.options || !config.options[optionType]) {
    console.warn(`Missing options for ${campaignType} - ${optionType}`);
    return [];
  }
  return config.options[optionType];
};

/**
 * Get field labels for a campaign type
 * @param {string} campaignType - The campaign type
 * @returns {Object} Field labels object
 */
export const getFieldLabels = (campaignType) => {
  const config = CAMPAIGN_TYPE_OPTIONS[campaignType];
  return config?.fieldLabels || { source: "Source", id: "ID" };
};

/**
 * Get field configuration for a campaign type
 * @param {string} campaignType - The campaign type
 * @returns {Array} Array of field configurations
 */
export const getFieldConfig = (campaignType) => {
  const config = CAMPAIGN_TYPE_OPTIONS[campaignType];
  const fieldConfigType = config?.fieldConfig || "default";
  return (
    CAMPAIGN_FIELD_CONFIGS[fieldConfigType]?.fields ||
    CAMPAIGN_FIELD_CONFIGS.default.fields
  );
};

/**
 * Get all campaign types as dropdown options
 * @returns {Array} Array of campaign type options
 */
export const getCampaignTypesList = () => {
  return Object.keys(CAMPAIGN_TYPE_OPTIONS).map((key) => ({
    label: CAMPAIGN_TYPE_OPTIONS[key].label,
    value: key,
  }));
};

/**
 * Build the complete config in the format the MultiLevelBuilder expects
 * @returns {Object} Complete campaign configuration
 */
export const buildCampaignConfig = () => {
  return {
    maxSubSteps: 3,
    lists: LISTS,
    campaignTypes: getCampaignTypesList(),

    getOptions: (campaignType, optionType) =>
      getCampaignOptions(campaignType, optionType),
    getLabels: (campaignType) => getFieldLabels(campaignType),
    getFields: (campaignType) => getFieldConfig(campaignType),
  };
};

export default buildCampaignConfig;
